<template>
  <v-container fluid class="py-0">
    <v-row class="py-4 text-center justify-center max-width-1200 mx-auto" align="center">
      <v-col
        cols="12" sm="12" md="4" lg="4"
        class="py-10">
        <v-row>
          <v-col class="pb-0 display-1 text-center">
            {{ $t('counter.telco') }}
          </v-col>
        </v-row>
        <v-row
          v-for="(item,index) in counter.group1"
          :key="index">
          <v-col class="pb-0 counter-text">
            {{ $t(item.text) }}
          </v-col>
        </v-row>
      </v-col>

      <v-col
        cols="12" sm="12" md="4" lg="4"
        class="py-10 px-7 border-left-dark border-right-dark">
        <!-- <v-row
          v-for="(item,index) in counter.group2"
          :key="index">
          <v-col class="pb-0">
            <v-row>
              <v-col class="pb-0 counter-number">
                {{ item.number }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-2 counter-text">
                {{ item.text }}
              </v-col>
            </v-row>
          </v-col>
        </v-row> -->
        <v-row>
          <v-col
            cols="6"
            v-for="(item,index) in counter.group2"
            :key="index">
            <v-sheet
              class="mx-auto"
              color="primary"
              height="160">
              <v-col class="pb-0 white--text">
                <v-row>
                  <v-col class="pb-0 pt-6 counter-number">
                    {{ item.number }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pt-2 counter-text">
                    {{ $t(item.text) }}
                  </v-col>
                </v-row>
              </v-col>
            </v-sheet>
          </v-col>
        </v-row>
        <!-- <v-row
          v-for="(item,index) in counter.group2"
          :key="index">
          <v-col class="pb-0 counter-text">
            {{ item.number}} {{ item.text}}
          </v-col>
        </v-row> -->
      </v-col>

      <v-col
        cols="12" sm="12" md="4" lg="4"
        class="mb-8 py-10">
        <v-row>
          <v-col class="pb-0 display-1 text-center">
            {{ $t('counter.industry') }}
          </v-col>
        </v-row>
        <v-row
          v-for="(item,index) in counter.group3"
          :key="index">
          <v-col class="pb-0 counter-text">
            {{ $t(item.text) }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'Counter',
    extends: DataComponentBase,

    data() {
      return {
        counter: {
          group1: [
            { text: 'counter.g1.01' },
            { text: 'counter.g1.02' },
            { text: 'counter.g1.03' },
          ],
          group2: [
            { number: "2",  icon: "", text: 'counter.g2.01' },
            { number: "41", icon: "", text: 'counter.g2.02' },
            { number: "16", icon: "", text: 'counter.g2.03' },
            { number: "7",  icon: "", text: 'counter.g2.04' },
          ],
          group3: [
            { text: 'counter.g3.01' },
            { text: 'counter.g3.02' },
          ],
        },
      }
    },
  }
</script>
